"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.attachAsyncAppsFromManifest = void 0;
/**
 * This is to load run-time / async federated apps.
 * We need to change the remote entry url to the manifest url.
 * @param remoteApps
 * @param manifestFederatedApps
 * @returns
 */
const attachAsyncAppsFromManifest = (remoteApps = {}, nodeEnv) => {
    const manifestFederatedAppsKeys = window.__APP_MANIFEST__?.federatedApps;
    if (!manifestFederatedAppsKeys) {
        console.warn("window.__APP_MANIFEST__ is not defined");
        return remoteApps;
    }
    const FederatedApps = Object.keys(remoteApps);
    Object.keys(manifestFederatedAppsKeys).forEach((app) => {
        if (FederatedApps.includes(app)) {
            remoteApps[app] = manifestFederatedAppsKeys[app];
        }
    });
    return remoteApps;
};
exports.attachAsyncAppsFromManifest = attachAsyncAppsFromManifest;
//# sourceMappingURL=attach-async-apps-from-manifest.js.map